<template>
    <Layout>
        <section class="section" style="min-height: 500px">
            <div class="container">
                <div class="">
                    <h3>404</h3>
                    <p class="lead">Page not found</p>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>

import Layout from '@/components/layouts/Layout.vue'

export default {
  name: 'Accommodation',
  components: {Layout}
};
</script>
